import { LuClock } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const scheduleNav: NavItem[] = [
  {
    icon: LuClock,
    label: 'Horario',
    hint: 'Horario de atención y días cerrados',
    to: '/horario',
    placement: 'more',
  },
];
